<div class="page-section">
	<div class="page-heading-details-section">
		<div class="page-heading-section">
			<img src="assets/back.png" class="page-back-icon" (click)="back()" />
			<!-- <span>AI Advisor Assistant</span> -->
			<!-- <span>MAGI</span> -->
			<span>MAGI (for existing clients)</span>
			<!-- <span>AI Assistant</span> -->
			<div class="section-heading-tooltip-block">
				<img src="assets/info-black.png" />
				<div class="section-heading-tooltip-section">
					<div class="module-page-information-section" *ngFor="let section of description_sections">
						<div class="each-module-page-information-section">
							<p class="each-module-page-information-heading">{{section.name}}</p>
						</div>
						<ng-container *ngIf="section.sub_sections">
							<ng-container *ngFor="let sub_section of section.sub_sections; let index = index">
								<div class="each-module-page-information-sub-section">
									<p class="each-module-page-information-sub-heading">{{index + 1}}. {{sub_section.name}}:</p>
									<p class="each-module-page-information-sub-content">{{sub_section.value}}</p>
									
									<ng-container *ngIf="sub_section.sub_sections">
										<div class="each-module-page-information-sub-section" *ngFor="let sub_section of sub_section.sub_sections; let index = index">
											<p class="each-module-page-information-sub-heading">{{index + 1}}) {{sub_section.name}}:</p>
											<p class="each-module-page-information-sub-content">{{sub_section.value}}</p>
										</div>
									</ng-container>
									
								</div>
							</ng-container>
						</ng-container>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class="page-content-section">
		<!-- <div class="page-tabs-section">
			<div class="each-page-tab-section" [ngClass]="{'each-page-tab-selected-section': selected_digital_advisor_tab == 'Assigned Clients' }" (click)="tabChange('Assigned Clients')" >
				<span>Assigned Clients ({{(tab_count_data.assigned_clients).toLocaleString('en-US')}})</span>
			</div>
			<div class="each-page-tab-section" [ngClass]="{'each-page-tab-selected-section': selected_digital_advisor_tab == 'Unassigned Clients' }" (click)="tabChange('Unassigned Clients')" >
				<span>Unassigned Clients ({{(tab_count_data.unassigned_clients).toLocaleString('en-US')}})</span>
			</div>
			<div class="each-page-tab-section" [ngClass]="{'each-page-tab-selected-section': selected_digital_advisor_tab == 'AI Differentiator'}" (click)="tabChange('AI Differentiator')">
				<span>AI Differentiator</span>
			</div>
			<div class="each-page-tab-section" [ngClass]="{'each-page-tab-selected-section': selected_digital_advisor_tab == 'Clients' }" (click)="tabChange('Clients')" >
				<span>Clients ({{(tab_count_data.assigned_clients).toLocaleString('en-US')}})</span>
			</div>
			<div class="each-page-tab-section" [ngClass]="{'each-page-tab-selected-section': selected_digital_advisor_tab == 'Prospects' }" (click)="tabChange('Prospects')" >
				<span>Prospects ({{(tab_count_data.assigned_prospects).toLocaleString('en-US')}})</span>
			</div>
		</div> -->
		<ng-container *ngIf="selected_digital_advisor_tab == 'Unassigned Clients'">
			<app-assistant-unassigned-clients [selected_opportunity_period]="selected_opportunity_period" (countChanged)="tabChange(selected_digital_advisor_tab)"></app-assistant-unassigned-clients>
		</ng-container>

		<ng-container *ngIf="selected_digital_advisor_tab == 'Assigned Clients'">
			<app-assistant-assigned-clients [selected_opportunity_period]="selected_opportunity_period" (countChanged)="tabChange(selected_digital_advisor_tab)"></app-assistant-assigned-clients>
		</ng-container>

		<ng-container *ngIf="selected_digital_advisor_tab == 'AI Differentiator'">
			<app-assistant-differentiator></app-assistant-differentiator>
		</ng-container>

		<ng-container *ngIf="selected_digital_advisor_tab == 'Clients'">
			<app-agi-clients [selected_opportunity_period]="selected_opportunity_period" (countChanged)="tabChange(selected_digital_advisor_tab)"></app-agi-clients>
		</ng-container>

		<ng-container *ngIf="selected_digital_advisor_tab == 'Prospects'">
			<app-agi-prospects [selected_opportunity_period]="selected_opportunity_period" (countChanged)="tabChange(selected_digital_advisor_tab)"></app-agi-prospects>
		</ng-container>

	</div>
</div>
